let freight = resolve =>
  require(["@/components/logistics/freight/freight"], resolve);
let addfreight = resolve =>
  require(["@/components/logistics/freight/addfreight"], resolve);
export default [
  {
    path: "/homeMain/logistics/freight",
    attr: "运费模板",
    component: freight,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/homeMain/logistics/addfreight",
    attr: "添加运费模板",
    component: addfreight
  }
];



// WEBPACK FOOTER //
// ./src/router/logistics.js